import React, { useEffect } from "react";

function ViralLoopsFormWidget({ ucid, popup, tag }: { ucid: string; popup?: boolean; tag: string }) {
  async function loadViralLoops() {
    const SCRIPT_SRC = "https://app.viral-loops.com/widgetsV2/core/loader.js";
    // const SCRIPT_SRC = "";
    const loadViralLoops = new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
        resolve(true);
      } else {
        const script = document.createElement("script");
        script.src = SCRIPT_SRC;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      }
    });
    const load = await loadViralLoops;
    console.log("load_viralloops", load);
    return load;
  }

  useEffect(() => {
    loadViralLoops();
  }, []);

  if (!ucid) return null;

  const renderWidget = () => {
    switch (tag) {
      case "form-widget":
        return <form-widget ucid={ucid} popup={popup ? "true" : "false"}></form-widget>;
      case "rewards-widget":
        return <rewards-widget ucid={ucid} />;
      case "leaderboard-widget":
        return <leaderboard-widget ucid={ucid} />;
      case "progress-tracking-widget":
        return <progress-tracking-widget ucid={ucid} />;
      case "milestone-widget":
        return <milestone-widget ucid={ucid} />;
      default:
        return <form-widget ucid={ucid} popup={popup ? "true" : "false"}></form-widget>;
    }
  };

  return renderWidget();
}

export default ViralLoopsFormWidget;
